// Cart section responses do not carry header settings. Preserve header artwork only;
// the existing renderers still own the count, accessible label and click listener.
if (!customElements.get('header-cart-icon')) {
  customElements.define('header-cart-icon', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => this.restoreArtwork());
      this.observer.observe(this, { childList: true, subtree: true });
      this.restoreArtwork();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    restoreArtwork() {
      const link = this.querySelector('#cart-icon-bubble');
      const template = this.querySelector('template');
      if (!link || !template) return;
      const nativeArtwork = Array.from(link.children).find((node) => node.classList.contains('svg-wrapper'));
      if (!nativeArtwork) return;
      const artwork = template.content.firstElementChild;
      if (!artwork) return;
      nativeArtwork.replaceWith(artwork.cloneNode(true));
    }
  });
}
